import apiClient from './api';
import { PositionEnum } from "./user";
import { LeaderboardData } from "../types";

interface LeaderboardFilters {
  class_year?: number | null;
  position?: PositionEnum | string | null;
  limit?: number | null;
  school_email_suffix?: string | null;
}

/**
 * Fetches the leaderboard data from the backend, ordered by Elo.
 * Supports filtering by class year, position, limit, and school email suffix.
 * @param filters - Optional filters for class_year, position, limit, and school_email_suffix.
 * @returns A promise that resolves to a LeaderboardData object.
 * @throws Throws an error if the fetch fails.
 */
export async function getLeaderboard(
  filters: LeaderboardFilters = {}
): Promise<LeaderboardData> {
  if (process.env.NODE_ENV === 'development') console.log(`[leaderboard.ts] Fetching leaderboard with filters:`, filters);

  try {
    const response = await apiClient.get('/users/leaderboard', {
      params: filters
    });

    return response.data;
  } catch (error: any) {
    if (process.env.NODE_ENV === 'development') console.log(`[leaderboard.ts] Failed to fetch leaderboard:`, error);
    if (error.response && error.response.data) {
      throw new Error(`Failed to fetch leaderboard: ${error.response.data.detail || error.message}`);
    }
    throw new Error(`Failed to fetch leaderboard: ${error.message}`);
  }
}
